export class ProtocolDetModel{
  prHdCode ='' ;
  prDetCategory='' ;
  prDetCatName ='';
  prDetItCode ='' ;
  prDetItName = '';
  prDetUnitCode ='';
  prDetUnit ='' ;
  prDetDose = 0;
  prDetQty =0;
  prDetRote = 0;
  prepFD = '00.00';
  prepsisp = '00.00';
  prepsaved = '00.00';
  prDetDuration ='' ;
  prDetNotes ='' ;
  prDetStep ='' ;
  compCode ='' ;
  userID ='' ;
  modifiedDate ='2022-01-01' ;

}

